import type { TFunction } from 'i18next'

export type SystemValueGroup =
  | 'projectType'
  | 'incidentPerimeter'
  | 'incidentType'
  | 'controlNature'
  | 'state'

/** Translate a stored system value (often French) for the active locale. */
export function systemLabel(
  t: TFunction,
  group: SystemValueGroup,
  value: string
) {
  if (!value) return ''
  return String(
    t(`systemValues.${group}.${value}`, { defaultValue: value })
  )
}
